export const PAGES_EN = {
    HOME: '/',
    ABOUT: '/about/',
    CONSTELLATION: '/constellation/',
    LEGAL: '/legal/',
    ARTISTS: '/artists/',
    CHAPTERS: '/chapters/',
}

export const PAGES_DE = {
    HOME: '/de/',
    ABOUT: '/de/about/',
    CONSTELLATION: '/de/constellation/',
    LEGAL: '/de/impressum/',
    ARTISTS: '/de/artists/',
    CHAPTERS: '/de/chapters/',
}

export const getRoutesByLocale = (lang: 'de' | 'en') => {
    if (lang === 'de') {
        return PAGES_DE
    }

    if (lang === 'en') {
        return PAGES_EN
    }
}
